<template>
  <div class="bk-editable-field-frame">
    <iframe
      ref="iframe"
      :style="{ height: Math.max(height, 150) + 'px' }"
      :src="url"
    />
  </div>
</template>

<script setup>
import { useBlokkli, ref, computed, onMounted, onBeforeUnmount } from "#imports";
const { adapter } = useBlokkli();
const props = defineProps({
  modelValue: { type: String, required: true },
  type: { type: String, required: true },
  fieldName: { type: String, required: true },
  host: { type: Object, required: true },
  initialHeight: { type: Number, required: true }
});
const height = ref(props.initialHeight);
const url = computed(() => {
  if ("itemBundle" in props.host) {
    return adapter.buildEditableFrameUrl({
      uuid: props.host.uuid,
      fieldName: props.fieldName
    });
  }
  return adapter.buildEditableFrameUrl({
    fieldName: props.fieldName
  });
});
const original = ref("");
const emit = defineEmits(["update:modelValue", "close"]);
const onMessage = (e) => {
  if (typeof e.data === "object") {
    if (e.data.name === "blokkli__editable_field_update") {
      emit("update:modelValue", e.data.data.text);
    } else if (e.data.name === "blokkli__editable_field_update_height") {
      height.value = e.data.data.height;
    }
  }
};
onMounted(() => {
  original.value = props.modelValue;
  height.value = props.initialHeight + 48;
  window.addEventListener("message", onMessage);
});
onBeforeUnmount(() => {
  window.removeEventListener("message", onMessage);
});
</script>
